import { App as CapApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { navigateTo } from './navigation';

/**
 * Universal / app links. The platform hands the running app the URL that opened it — nothing
 * routes it for us, so the path is pushed onto the router by hand. The domains that qualify
 * are the ones `scripts/generate-wellknown.mjs` publishes per build mode.
 */
export function initDeepLinks(): void {
  if (!Capacitor.isNativePlatform()) return;

  void CapApp.addListener('appUrlOpen', ({ url }) => {
    const route = routeFromDeepLink(url);
    if (!route) return;
    navigateTo(route);
  });
}

/** The only screens an external link may open: invites, password reset, onboarding, the app itself. */
const LINKABLE_ROUTES = /^\/(access\/|reset-password|onboarding|app\/)/;

/** The in-app route an incoming link names, or null when it names none. */
export function routeFromDeepLink(url: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  // A universal link (`https://estate.example/access/invite/x`) carries the whole route in
  // its pathname; a custom-scheme link (`ip4estates://access/invite/x`) loses its first
  // segment to `host`, so put it back.
  const path = parsed.protocol.startsWith('http')
    ? parsed.pathname
    : `/${parsed.host}${parsed.pathname}`;

  return LINKABLE_ROUTES.test(path) ? path + parsed.search : null;
}
